import React from 'react';

const Timeline = ({ timeline, isMobile = false }) => {
  return (
    <div className={`${isMobile ? 'relative' : 'flex items-start justify-between'} p-6 bg-gray-50 rounded-xl`}>
      {isMobile && (
        <div className="absolute left-11 top-14 bottom-6 w-0.5 bg-gray-300"></div>
      )}
      
      {timeline.map((item, index) => (
        <div key={index} className={`${isMobile ? 'flex items-start space-x-4 mb-4 relative z-10' : 'flex flex-col items-center text-center flex-1 relative'}`}>
          <div className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold text-sm ${
            item.completed ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-600'
          } ${isMobile ? 'flex-shrink-0 relative z-20' : 'mb-3'}`}>
            {item.completed ? '✓' : index + 1}
          </div>
          <div className={isMobile ? '' : 'text-center'}>
            <h4 className="font-semibold text-gray-900 text-sm mb-1">{item.step}</h4>
            <p className="text-gray-600 text-xs">{item.date}</p>
          </div>
          {!isMobile && index < timeline.length - 1 && (
            <div className={`absolute top-5 h-0.5 ${
              item.completed ? 'bg-green-500' : 'bg-gray-300'
            } z-0`} style={{left: 'calc(50% + 20px)', right: 'calc(-50% + 20px)'}}></div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Timeline;